import React from 'react';
import PropTypes from 'prop-types';
import { optimiseImage } from 'src/common/utils/prismic-image';
import './FullWidthImage.scss';

const FullWidthImage = props => (
  <section className="full-width-image" id={props.id}>
    <img src={optimiseImage(props.image.url)} alt="" />
  </section>
);

FullWidthImage.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default FullWidthImage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/FullWidthImage/FullWidthImage.js